import axiosInstance from '../../../helpers/axiosInstance';

export default {
  getBatchTypes: () => axiosInstance().get('batch-types'),
};
